<template>
    <div v-if="config.display" :style="{'width': config.width || '100%'}" :class="config.cssClass">
        <ejs-contextmenu
            v-bind="syncfusionConfig"
            :ref="config.ref || config.id"
            :items='options'
            @select="action($event, 'onclick')"
            :data-test-id="dataTestId">
        </ejs-contextmenu>
    </div>
</template>

<script>
import { enableRipple } from '@syncfusion/ej2-base';
import { defineAsyncComponent } from "@common/defineAsyncComponent";
import { controlMixins } from "./controlMixins.js";

enableRipple(true);
let editorSettings = {};

export const contextMenuCmp = {
    editorSettings: editorSettings,
    mixins: [controlMixins],
    components: {
        "ejs-contextmenu": defineAsyncComponent(() => import('@common/syncfusion/contextMenu'))
    }
};

export default contextMenuCmp;
</script>
